import HeroBanner from "../components/HeroBanner";
import PurposeSection from "../components/PurposeSection";
// import ModernIndia from "../components/ModernIndia";
import ModernIndia2 from "../components/ModernIndia2";
// import ExperienceSection from "../components/ExperienceSection";
import ReservationBanner from "../components/ReservationBanner";
const Home = () => {
  return (
    <div>
      <HeroBanner />
      <PurposeSection />
      <ModernIndia2 />
      {/* <ExperienceSection /> */}
      <ReservationBanner />
    </div>
  );
};

export default Home;
